import React, {useState} from 'react'
import Breadcrumb from '../../../common/breadcrumb';
import LoadingIndicator from '../../../common/loadingIndicator';
import FuelReportFilters from './fuelReportFilters';

/**
 * Fuel Report.
 * @returns {JSX.Element}
 * @constructor
 */
const FuelReport = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            <Breadcrumb title="Fuel Report" parent="Reports" />
            <FuelReportFilters setIsLoading={setIsLoading} />
            <LoadingIndicator isLoading={isLoading} />
        </>
    );
}

export default FuelReport;
